import React, { FC, useState, useRef, useEffect, useMemo } from "react";
import styles from "./desktop-program.module.scss";
import ProgramJobCard from "../../JobListingProgramSearcher/ProgramJobCard";
interface ProgramsListingProps {
  programsDetails: {
    categoryParentTitle: string;
    categoryTitle: string;
    programsList: any[];
  };
  onCloseHandler: (href:string) => void;
}

const DProgramsListing: FC<ProgramsListingProps> = ({ programsDetails, onCloseHandler }) => {
  const [visiblePrograms, setVisiblePrograms] = useState(8);
  const observerRef = useRef<HTMLDivElement | null>(null);
  const previousCategoryRef = useRef<string>(programsDetails.categoryTitle);
  const allLoaded = visiblePrograms >= programsDetails.programsList.length;

  // Reset visible programs when category changes
  useEffect(() => {
    if (previousCategoryRef.current !== programsDetails.categoryTitle) {
      setVisiblePrograms(8); // Reset to initial count
      previousCategoryRef.current = programsDetails.categoryTitle;
    }
  }, [programsDetails.categoryTitle]);

  const visibleProgramsList = useMemo(
    () => programsDetails.programsList.slice(0, visiblePrograms),
    [programsDetails.programsList, visiblePrograms]
  );

  // Intersection Observer to load more items when the observer element is visible
  useEffect(() => {
    // Only set up observer if we haven't loaded all programs
    if (allLoaded) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setVisiblePrograms((prev) =>
            Math.min(prev + 8, programsDetails.programsList.length)
          );
        }
      },
      {
        threshold: 0.1,
        rootMargin: "100px",
      }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [visiblePrograms, programsDetails.programsList.length, allLoaded]);

  return (
    <div className={`${styles.programsListingMainContainer}`}>
      {" "}
      <span className={styles.programListTitle}>
        {programsDetails?.categoryTitle === "KPMG PROGRAM" ? "KPMG" : programsDetails?.categoryTitle}
      </span>
      <div className={styles.programsListingWrapper}>
        {visibleProgramsList.map((program, index) => (  
          // <ProgramCard key={index} program={program} programsDetails={programsDetails} onCloseHandler={onCloseHandler}/>
          <ProgramJobCard key={index} program={program} programsDetails={programsDetails} onCloseHandler={onCloseHandler}/>
        ))}

        {!allLoaded && (
          <div
            ref={observerRef}
            className={styles.loadingIndicator}
            aria-live="polite"
          >
            Loading more...
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(DProgramsListing);
